export default [
	{
		path: '/subscriber/subscriberinformationlookup',
		name: 'subscriber-information-lookup',
		component: () => import(/* webpackChunkName: "subscriber" */ '@/views/subscriber/SubscriberInformationLookup.vue')
	},
	{
		path: '/subscriber/subscriberinformation',
		name: 'subscriber-information',
		component: () => import(/* webpackChunkName: "subscriber" */ '@/views/subscriber/SubscriberInformation.vue')
	},
	{
		path: '/subscriber/searchpackage',
		name: 'search-package',
		component: () => import(/* webpackChunkName: "subscriber" */ '@/views/subscriber/SearchPackage.vue')
	},
	{
		path: '/subscriber/searchcrs',
		name: 'search-crs',
		component: () => import(/* webpackChunkName: "subscriber" */ '@/views/subscriber/SearchCRS.vue')
	},
	{
		path: '/subscriber/subscriberContent',
		name:'subcriber-content',
		component:()=>import(/* webpackChunkName: "subscriber" */ '@/views/subscriber/ListSubcriberContent.vue')
	},
	{
		path: '/subscriber/information',
		name: 'subscriber-info-page',
		component: () => import(/* webpackChunkName: "subscriber" */ '@/views/subscriber/SubscriberInfoPage.vue')
	},
	{
		path: '/subscriber/corporate-subscribe-info',
		name: 'subscriber-info-page',
		component: () => import(/* webpackChunkName: "subscriber" */ '@/views/subscriber/CorporateSubscriberInfo.vue')
	},
]
